module.exports = __webpack_public_path__ + "static/media/spring.b9c49ba8.png";